import React from "react";

export default function OpenKPIIcon() {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10L9.78423 7.21577M5.3125 1.5625H8.6875M13.1875 10C13.1875 13.4173 10.4173 16.1875 7 16.1875C3.58274 16.1875 0.8125 13.4173 0.8125 10C0.8125 6.58274 3.58274 3.8125 7 3.8125C10.4173 3.8125 13.1875 6.58274 13.1875 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
